var styles = {"box":"BabyButton_box_vlc6m_1","wallet":"BabyButton_wallet_vlc6m_20","button-icon":"BabyButton_button-icon_vlc6m_20","vip":"BabyButton_vip_vlc6m_24","with-count":"BabyButton_with-count_vlc6m_24","user":"BabyButton_user_vlc6m_27","chat":"BabyButton_chat_vlc6m_31","count":"BabyButton_count_vlc6m_35","image":"BabyButton_image_vlc6m_54","sm":"BabyButton_sm_vlc6m_77"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
